class CiariMechanism extends HTMLElement {
  connectedCallback() {
    this.video = this.querySelector('[data-cme-video]');
    if (!this.video) return;

    this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !this.reducedMotion.matches) {
        this.video.play().catch(() => {});
        return;
      }

      this.video.pause();
    }, { rootMargin: '200px 0px', threshold: 0.1 });

    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer?.disconnect();
    this.video?.pause();
  }
}

if (!customElements.get('ciari-mechanism')) {
  customElements.define('ciari-mechanism', CiariMechanism);
}
